export default {"src":"/_next/static/media/deco_label_shadow.4686a67e.svg","height":68,"width":128,"blurWidth":0,"blurHeight":0};